import styled from "styled-components";
import { Card, Typography } from "antd";

// ─── SBI Card ─────────────────────────────────────────────────────────────────
// Body padding is set via the AntD `styles` prop at the call site — no .ant-card-body override.

export const SbiCardStyled = styled(Card)`
  && {
    border: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  }
`;

export const SbiLabelStyled = styled(Typography.Text)`
  && {
    font-size: 12px;
    font-weight: 600;
    color: ${(p) => p.theme?.colors?.primary ?? "#008080"};
    text-transform: uppercase;
    letter-spacing: 0.4px;
    line-height: 1.5;
  }
`;

export const SbiValueStyled = styled(Typography.Text)`
  && {
    font-size: 24px;
    font-weight: 700;
    color: ${(p) => p.theme?.colors?.primary ?? "#008080"};
    flex-shrink: 0;
  }
`;
